import { render, staticRenderFns } from "./buy-team.vue?vue&type=template&id=3ab68ac3&"
import script from "./buy-team.vue?vue&type=script&lang=js&"
export * from "./buy-team.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports